import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const styles = () => ({
    browser: {
        width: '80%',
        margin: '20px auto 0',
        border: '1px solid #d7d7d7',
        borderRadius: 5,
        height: 280,
        overflow: 'auto',
        '& .browser-content .search-bar': {
          backgroundColor: '#222',
          padding: '11px 15px',
        },
        '& .browser-content .search-bar .logo': {
          width: 95,
          height: 35,
          backgroundSize: 95,
          backgroundPosition: 'center center',
          backgroundImage: `url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/6444/googlelogo_color_272x92dp.png)`,
          backgroundRepeat: 'no-repeat',
          float: 'left',
          marginTop: 4,
          marginBottom: 0,
        },
        '& .browser-content .results': {
          marginLeft: 130,
          maxWidth: 600,
          padding: '10px 0',
        },
        '& .browser-content .results .pager-totals': {
          display: 'block',
          color: '#d7d7d7',
          fontSize: 13,
          marginBottom: 25,
        },
        '& .browser-content .results .results-inner': {
          margin: 0,
          padding: 0,
        },
        '& .browser-content .results .results-inner li': {
          listStyleType: 'none',
          marginBottom: 25,
        },
        '& .browser-content .results .results-inner li .link': {
          color: '#FFF',
          textDecoration: 'none',
          cursor: 'pointer',
        },
        '& .browser-content .results .results-inner li cite': {
          color: '#f7d68c',
          display: 'block',
          fontSize: 14,
          fontWeight: 'normal',
          fontStyle: 'normal',
          lineHeight: 1.6,
        },
        '& .browser-content .results .results-inner li cite:after': {
          content: '""',
          display: 'inline-block',
          marginLeft: 5,
          top: -2,
          position: 'relative',
          width: 0,
          height: 0,
          borderStyle: 'solid',
          borderWidth: '5px 4px 0 4px',
          borderColor: '#00591E transparent transparent transparent',
        },
        '& .browser-content .results .results-inner li .desc': {
          color: '#d7d7d7',
          fontSize: 14,
          lineHeight: 1.4,
          display: 'block',
          overflow: 'visible',
          overflowWrap: 'break-word',
        }
      },
      searchBarInput: {
          position: 'relative',
          maxWidth: 600,
          marginLeft: 115,
        '& input': {
          backgroundColor: '#000',
          color: '#d7d7d7',
          border: 0,
          borderRadius: 32,
          borderRight: 'none',
          float: 'left',
          width: 'calc(100% - 40px)',
          height: 40,
          lineHeight: 40,
          outline: 'none',
          padding: '0 0 0 10px',
          fontFamily: 'arial, sans-serif',
          fontSize: 16,
        },
        '& button': {
          backgroundColor: '#000',
          border: 0,
          width: 80,
          height: 40,
          float: 'left',
          padding: 0,
          marginLeft: -80,
          borderRadius: '0 32px 32px 0',
          fontSize: 14,
          fontWeight: 500,
          color: '#d7d7d7',
        },
        '&::after': {
          clear: 'both',
          content: '""',
          display: 'table',
        },
      },
      browserChorme: {
        backgroundColor: '#000',
        height: 40,
        position: 'relative',
      },
      browserChormeControls: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        left: 10,
        '& span': {
          backgroundColor: '#ffffff',
          borderRadius: '50%',
          width: 12,
          height: 12,
          float: 'left',
          marginRight: 8,
        },
      },
})
class BrowserSearch extends Component {
  limitContent = (text, count) => {
    return text.slice(0, count) + (text.length > count ? "..." : "");
  }
    render() {
        const {classes, meta_keywords, meta_title, meta_description, slug, title, domain} = this.props;
        return (
            <div className={classes.browser}>
                <div className={classes.browserChorme}>
                    <div className={classes.browserChormeControls}>
                    <span className="bgDanger" />
                    <span className="bgWarning" />
                    <span className="bgSuccess" />
                    </div>
                </div>
                <div className="browser-content">
                    <div className="search-bar">
                    <div className="logo" />
                    <div className={classes.searchBarInput}>
                        <input type="search" value={meta_keywords ? meta_keywords.split(',')[0] : ''} disabled />
                        <button>Tìm kiếm</button>
                    </div>
                    </div>
                    <div className="results">
                    <p className="pager-totals">About 1,220,000,000 results (0.77 seconds)</p>
                    <ul className="results-inner">
                        <li>
                        <span className="link">{meta_title ? this.limitContent(meta_title, 65) : title}</span>
                        <cite>https://{domain ? domain : 'ten-mien'}/{slug ? slug : 'tieu-de'}</cite>
                        <span className="desc">{meta_description ? this.limitContent(meta_description, 165) : 'Thẻ mô tả ở đây'}</span>
                        </li>
                    </ul>
                    </div>
                </div>
            </div>
        )
    }
}

BrowserSearch.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withStyles(styles)(BrowserSearch);
